import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "personInsideMessageBubbleAndHand",
    iconColor: "white",
    text: "AI-powered identity \nexchange",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "worldAndSchemeLine",
    iconColor: "white",
    text: "Smart identity \nharmonization and data \nfabric across data \ndomains",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "personFocused",
    iconColor: "white",
    text: "Smart data governance \nfor privacy, compliance \nand security",
    listItemCustomStyle: { width: "254px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_AI_TWIN_3 = {
  title: "90% INCREASE IN FIRST PARTY DATA \nHARNESSING WITH AI DRIVEN LINKING",
  titleNumber: "3.",
  text: "Seeding the foundation for cookie-less customer identity collaboration and connect the \nunconnected consumer data universe with AI driven identity resolution and fingerprinting with\n privacy and security at core.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("AITWIN_312"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("AITWIN_303"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_05.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "AI_TWIN/InfosysTopazLogo.png",
};
